<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableNatGatewayResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "accountIdString"
        },
        {
          title: "区域",
          key: "region"
        },
        {
          title: "网关名称",
          key: "name"
        },
        {
          title: "NAT网关ID",
          key: "natGatewayId"
        },
        {
          title: "状态",
          key: "state"
        },
        {
          title: "弹性IP地址",
          key: "publicIp"
        },
        {
          title: "私有IP地址",
          key: "privateIp"
        },
        {
          title: "网络接口ID",
          key: "networkInterfaceId"
        },
        {
          title: "VPC",
          key: "vpcId"
        },
        {
          title: "子网",
          key: "subnetId"
        },
        {
          title: "创建时间",
          key: "createTime"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountIds", function(val) {
      tableDataVue.accountIds = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("natGatewayId", function(val) {
      tableDataVue.natGatewayId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .pagingQueryAWSNatGateway({
          companyId: tableDataVue.companyId,
          accountIdList: tableDataVue.accountIds,
          accountName: tableDataVue.accountName,
          natGatewayId: tableDataVue.natGatewayId,
          pageNum: this.current,
          pageSize: this.pageSize,
          accountType: 0
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("accountIds");
      eventBus.$off("accountName");
      eventBus.$off("natGatewayId");
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/nat_gateway/TableNatGatewayResource.vue